import { useTranslations } from 'next-intl';
import { Clickable } from '@mentimeter/ragnar-ui/clickable';
import { ArrowDownIcon, ArrowUpIcon } from '@mentimeter/ragnar-visuals';

interface QfaNavigationButtonProps {
  isDisabled: boolean;
  onClick: () => void;
  direction: 'up' | 'down';
}

export const QfaNavigationButton = ({
  isDisabled,
  onClick,
  direction,
}: QfaNavigationButtonProps) => {
  const t = useTranslations('presenting');

  return (
    <Clickable
      aria-label={t(
        'questions_from_audience.qfa_navigation_next_question_a11y',
      )}
      disabled={isDisabled}
      borderRadius="full"
      onClick={onClick}
      mb={3}
      bg="surfaceOverlayTransparent"
      p="space4"
      extend={() => ({
        visibility: isDisabled ? 'hidden' : 'visible',
      })}
    >
      {direction === 'up' ? (
        <ArrowUpIcon size={3} color="text" />
      ) : (
        <ArrowDownIcon size={3} color="text" />
      )}
    </Clickable>
  );
};
